import {
    BarPart,
    Container,
    GiftIcon,
    IconsContainer,
    Index,
    PinIcon,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/ProgressBarSection/ProgressBar/ProgressBar.styled";
import { useMemo } from "react";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";

interface IProgressBarProps {
    packages: IPackage[];
    invitationCount?: number;
}

const ProgressBar = ({ packages, invitationCount = 0 }: IProgressBarProps) => {
    const progressBarIndicators = useMemo(() => {
        return packages?.map((card) => card.ReferralsNumber - 1);
    }, [packages]);

    const maxReferrals = useMemo(() => {
        return Math.max(...packages?.map((card) => card.ReferralsNumber));
    }, [packages]);

    const barParts = Array.from({ length: maxReferrals }).map((_, index) => {
        const isPartFilled = index < invitationCount;
        const isIconIndex = progressBarIndicators.includes(index);
        const isLastPart = index === maxReferrals - 1;

        return (
            <BarPart
                key={index}
                isFilled={isPartFilled}
                isCurrent={index === invitationCount - 1}
                isLastPart={isLastPart}
            >
                <Index>{index + 1}</Index>
                {isIconIndex ? (
                    <IconsContainer isLastIndex={isLastPart}>
                        <PinIcon
                            iconName="round-pin"
                            isFilled={isPartFilled}
                        />
                        <GiftIcon
                            iconName="gift"
                            isFilled={isPartFilled}
                        />
                    </IconsContainer>
                ) : null}
            </BarPart>
        );
    });

    return <Container>{barParts}</Container>;
};

export default ProgressBar;
